<template>
  <div class="classification">
    <div class="card">
      <div class="staus_bar fl_bet border">
        <div class="detail_left">
          <div class="fl_cen">
            <div class="status">
              <img
                class="icon_status"
                :src="getStatus(1, orderList.status)"
                v-if="getStatus(1, orderList.status)"
              />
              <div class="name" :class="getStatus(3, orderList.status)">
                {{ getStatus(2, orderList.status) }}
              </div>
            </div>
            <div class="items">
              <div class="title">订单编号</div>
              <div style="height: 22px">{{ orderList.orderCode || "" }}</div>
            </div>
            <div class="items">
              <div class="title">下单时间</div>
              <div style="height: 22px">{{ orderList.orderTime || "" }}</div>
            </div>
            <div
              v-if="orderList.status == 1 && orderList.payTime"
              class="items"
            >
              <div class="title">付款时间</div>
              <div style="height: 22px; color: #e4393c">
                {{ orderList.payTime || " " }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="staus_plan fl_left">
        <div :class="indexStep >= 1 ? 'active' : ''" class="step">
          <div class="fl_center">
            <div class="status">
              <el-image v-if="indexStep > 1" class="icon_svg" :src="icon" />
              <div v-else class="idx">1</div>
            </div>
            <div class="name" :class="indexStep > 1 ? 'sueccss' : ''">
              提交订单
            </div>
          </div>
          <div class="time">{{ orderList.orderTime || "" }}</div>
        </div>
        <div :class="indexStep >= 1 ? 'active' : ''" class="line" />
        <div :class="indexStep >= 2 ? 'active' : ''" class="step">
          <div class="fl_center">
            <div class="status fl_center">
              <el-image v-if="indexStep > 2" class="icon_svg" :src="icon" />
              <div v-else class="idx">2</div>
            </div>
            <div class="name" :class="indexStep > 2 ? 'sueccss' : ''">
              付款成功
            </div>
          </div>
          <div class="time">{{ orderList.payTime || "" }}</div>
        </div>
        <div :class="indexStep >= 2 ? 'active' : ''" class="line" />
        <div :class="indexStep >= 3 ? 'active' : ''" class="step">
          <div class="fl_center">
            <div class="status">
              <el-image v-if="indexStep > 3" class="icon_svg" :src="icon" />
              <div v-else class="idx">3</div>
            </div>
            <div class="name" :class="indexStep > 3 ? 'sueccss' : ''">
              商品出库
            </div>
          </div>
          <div class="time">{{ orderList.deliveryTime || "" }}</div>
        </div>
        <div :class="indexStep >= 3 ? 'active' : ''" class="line" />
        <div :class="indexStep >= 4 ? 'active' : ''" class="step">
          <div class="fl_center">
            <div class="status">
              <el-image v-if="indexStep > 4" class="icon_svg" :src="icon" />
              <div v-else class="idx">4</div>
            </div>
            <div class="name" :class="indexStep > 4 ? 'sueccss' : ''">
              配送完成
            </div>
          </div>
          <div class="time">{{ orderList.finishDate || "" }}</div>
        </div>
        <div :class="indexStep >= 4 ? 'active' : ''" class="line" />
        <div :class="indexStep >= 5 ? 'active' : ''" class="step">
          <div class="fl_center">
            <div class="status">
              <el-image v-if="indexStep > 5" class="icon_svg" :src="icon" />
              <div v-else class="idx">5</div>
            </div>
            <div class="name" :class="indexStep > 5 ? 'sueccss' : ''">
              交易完成
            </div>
          </div>
          <div class="time">{{ orderList.finishDate || "" }}</div>
        </div>
      </div>
    </div>

    <div class="info card">
      <el-tabs
        v-model="orderLogistics"
        class="headerTabs"
        @tab-click="handleClick"
        v-if="orderLogisticsList.length > 0"
      >
        <el-tab-pane
          :label="item.label"
          :name="item.expressDeliveryNumber"
          v-for="(item, index) in orderLogisticsList"
          :key="index"
        >
          <span slot="label" style="font-size: 14px">
            <div v-if="item.expressTag == 1">
              <div>自主配送：{{ item.deliveryDriver || "--" }}</div>
              <div>联系电话：{{ item.driverPhone }}</div>
            </div>
            <div v-else>
              <div style="line-height: 20px">
                {{ item.kuaidiName }}
              </div>
              <div style="line-height: 20px">
                {{ item.expressDeliveryNumber }}
              </div>
            </div>
          </span>
        </el-tab-pane>
      </el-tabs>
      <el-collapse v-model="activeName">
        <el-collapse-item name="1">
          <template slot="title">
            <div style="line-height: 20px; height: 80px">
              <div style="color: #f56c6c; font-weight: 600">
                {{ expressData.step || "暂无物流数据" }}
              </div>
              <div>
                {{ expressData.description || "" }}
              </div>
            </div>
          </template>
          <div style="padding-top: 10px">
            <el-timeline v-if="expressChild && expressChild.length > 0">
              <el-timeline-item
                v-for="(activity, index) in expressChild"
                :key="index"
                color="#F5222D"
              >
                <div style="font-weight: 600">{{ activity.step || "" }}</div>
                <div>{{ activity.description || "" }}</div>
                <el-image
                  v-if="activity.image"
                  style="display: block; width: 100px; height: 100px"
                  :src="activity.image || ''"
                  :preview-src-list="[activity.image || '']"
                >
                </el-image>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="info card fl_cen">
      <div class="info_list">
        <div class="title">收件人信息</div>
        <div class="lists">
          <div class="item">
            <span>收货人：</span>{{ orderList.contactsName || "--" }}
          </div>
          <div class="item" style="height: auto">
            <span>地址：</span>{{ orderList.province || ""
            }}{{ orderList.city || "" }}{{ orderList.district || ""
            }}{{ orderList.address || "" }}
          </div>
          <div class="item">
            <span>手机号：</span>{{ orderList.contactsPhone || "--" }}
          </div>
        </div>
      </div>
      <div class="info_list">
        <div class="title">客户信息</div>
        <div class="lists">
          <div class="item">
            <span>客户名称: {{ orderList.payShopName }}</span>
          </div>
          <!-- <div class="item">
            <span>运营人员&联系方式：</span>
          </div> -->
        </div>
      </div>
      <div class="info_list">
        <div class="lists" style="margin-top: 0px">
          <!-- <div class="title">配送信息</div> -->
          <Tabs
            :tabsList="tabsList"
            class="title"
            :activeName.sync="tabsActiveName"
            @tab-click="handleChange"
          />
          <div v-if="this.tabsActiveName == '2'">
            <div class="item">
              <span>司机姓名：</span>{{ orderList.deliveryDriver || "--" }}
            </div>
            <div class="item">
              <span>联系方式：</span>{{ orderList.driverPhone || "--" }}
            </div>
          </div>
          <div v-else>
            <div class="item">
              <span>快递公司：</span>{{ orderList.kuaidiName || "--" }}
            </div>
            <div class="item">
              <span>快递单号：</span>{{ orderList.number || "--" }}
            </div>
          </div>
        </div>
      </div>
      <div class="info_list">
        <div class="title">付款信息</div>
        <div class="lists">
          <div class="item">
            <span>实付总额：</span
            >{{
              orderList.status == "1"
                ? "--"
                : `￥${orderList.totalPrice}` || "--"
            }}
          </div>
          <!-- <div class="item"><span>支付方式：</span>{{ orderList.payType == 3 ? '线下支付' : '在线支付' }}</div> -->

          <!-- 改为支付方式+支付金额 -->
          <!-- 支付方式：微信支付、支付宝支付、康贝支付、余额支付、线下对公打款 -->
          <div class="item">
            <span>支付方式：</span>
            <span
              v-if="
                orderList.balanceAmount &&
                parseFloat(orderList.balanceAmount) > 0
              "
            >
              余额支付 ￥
              {{ parseFloat(orderList.balanceAmount).toFixed(2) || "--" }}
            </span>
            <span
              v-if="
                orderList.balanceAmount &&
                parseFloat(orderList.balanceAmount) > 0 &&
                parseFloat(orderList.totalPrice) -
                  parseFloat(orderList.balanceAmount) >
                  0
              "
            >
              {{ orderList.payTypeName }}
              ￥
              {{
                (
                  parseFloat(orderList.totalPrice) -
                  parseFloat(orderList.balanceAmount)
                ).toFixed(2)
              }}
            </span>

            <span
              v-if="
                parseFloat(orderList.balanceAmount) == 0 ||
                orderList.balanceAmount == '0.00'
              "
            >
              {{ orderList.payTypeName }}
              ￥ {{ parseFloat(orderList.totalPrice).toFixed(2) || "--" }}
            </span>
          </div>
          <div class="item">
            <span>付款时间：</span>{{ orderList.payTime || "" }}
          </div>
        </div>
      </div>
    </div>
    <div class="commodity card">
      <!-- <publicTable :table-data="list"
                   :colum-obj="columObj"
                   :page-obj="pageObj" /> -->
      <el-table :data="list" style="width: 100%">
        <el-table-column label="商品信息" min-width="300">
          <template slot-scope="scope">
            <div class="commodity_info">
              <div class="img">
                <el-image
                  :src="scope.row.image || ''"
                  :preview-src-list="[scope.row.image || '']"
                />
              </div>
              <div class="goodsInfo">
                <div class="name">{{ scope.row.name || "" }}</div>
                <div class="factory">{{ scope.row.factory || "" }}</div>
              </div>
            </div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="img">
                <el-image
                  :src="giftItem.image || ''"
                  :preview-src-list="[giftItem.image || '']"
                />
              </div>
              <div class="goodsInfo">
                <div class="name">{{ giftItem.name || "" }}</div>
                <div class="factory">{{ giftItem.factory || "" }}</div>
                <!-- <GiftTag /> -->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="规格" width="120">
          <template slot-scope="scope">
            <div class="commodity_info">
              {{ scope.row.specification || "" }}
            </div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="specification">
                {{ giftItem.specification || "" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" width="120">
          <template slot-scope="scope">
            <div class="commodity_info">￥{{ scope.row.price || "" }}</div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="price">￥{{ giftItem.salePrice || "" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品数量" width="120">
          <template slot-scope="scope">
            <div class="commodity_info">{{ scope.row.qty || "0" }}</div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="qty">{{ giftItem.qty || "" }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="实发量" prop="shipmentsAmount" width="120">
          <template slot-scope="scope">
            <div class="commodity_info">
              {{ scope.row.shipmentsAmount || "0" }}
            </div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="qty">/</div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="批号" prop="batchNumber" width="200">
          <template slot-scope="scope">
            <div class="commodity_info">{{ scope.row.batchNumber || "" }}</div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="batchNumber">{{ giftItem.batchNumber || "" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="溯源码" prop="traceableCode" width="200">
          <template slot-scope="scope">
            <div class="commodity_info">
              {{ scope.row.traceableCode || "" }}
            </div>
            <div
              class="commodity_info"
              v-for="(giftItem, giftIndex) in scope.row.giftGoodsList"
              :key="giftIndex"
            >
              <div class="traceableCode">
                {{ giftItem.traceableCode || "" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商户促销" width="200">
          <template slot-scope="scope">
            <span
              class="commodity_info"
              style="
                font-weight: 400;
                color: #f5222d;
                font-size: 16px;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
              "
            >
              -￥{{ scope.row.couponDiscount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="平台补贴" width="200">
          <template slot-scope="scope">
            <span
              class="commodity_info"
              style="font-weight: 400; color: #f5222d; font-size: 16px"
            >
              -￥{{ scope.row.platformDiscount }}
            </span>
          </template>
        </el-table-column>
        <!-- 优惠 -->
        <el-table-column label="优惠" width="200">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <span style="color: #f5222d; font-size: 16px">
                -￥{{
                  getSumSalePrice(
                    scope.row.couponDiscount,
                    scope.row.platformDiscount,
                    scope.row.subsidyAmount
                  )
                }}
              </span>
              <order-discount-tooltip
                :sum-discount-money="scope.row.couponDiscount || '0.00'"
                :sum-platform-discount-money="
                  scope.row.platformDiscount || '0.00'
                "
                :sum-voucher-discount-money="scope.row.subsidyAmount || '0.00'"
                style="color: #f5222d"
              ></order-discount-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="小计" width="200">
          <template slot-scope="scope">
            <span
              class="commodity_info"
              style="
                font-weight: 600;
                color: #f5222d;
                font-size: 16px;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
              "
            >
              ￥{{ scope.row.smallPrice }}
              <!-- <div style="font-weight: 400;font-size: 14px;">
                优惠券：-￥{{ scope.row.couponDiscount }}
              </div>
              <div style="font-weight: 400;font-size: 14px;">
                平台补贴：-￥{{ scope.row.platformDiscount }}
              </div> -->
            </span>
            <!-- <div class="commodity_info" v-for="(giftItem, giftIndex) in scope.row.giftGoodsList" :key="giftIndex">

            </div> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="price_detail">
        <div class="items">
          <span class="left">商品数量</span>
          <span class="right">{{ orderList.sumQty || 0 }}</span>
        </div>
        <div class="items">
          <span class="left">商品总价：</span>
          <span class="right">¥{{ orderList.amount || "0.00" }}</span>
        </div>
        <div class="items">
          <span class="left">运费：</span>
          <span class="right">¥{{ orderList.freightPrice || "0.00" }}</span>
        </div>
        <!-- <div class="items">
          <span class="left">商户促销：</span>
          <span class="right">-¥{{ orderList.discountAmount || "0.00" }}</span>
        </div>
        <div class="items">
          <span class="left">平台补贴：</span>
          <span class="right"
            >-¥{{ orderList.platformDiscountAmount || "0.00" }}</span
          >
        </div> -->
        <div class="items">
          <span class="left">优惠：</span>
          <div class="right">
            <span
              >-¥{{
                getSumSalePrice(
                  orderList.discountAmount,
                  orderList.platformDiscountAmount,
                  orderList.totalSubsidyAmount
                )
              }}</span
            >
            <order-discount-tooltip
              :sum-discount-money="orderList.discountAmount || '0.00'"
              :sum-platform-discount-money="
                orderList.platformDiscountAmount || '0.00'
              "
              :sum-voucher-discount-money="
                orderList.totalSubsidyAmount || '0.00'
              "
              style="color: #f5222d"
            ></order-discount-tooltip>
          </div>
        </div>
        <div class="items">
          <span class="left">应付总额：</span>
          <span class="right all">¥{{ orderList.totalPrice || "0.00" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs";
import orderDiscountTooltip from "./components/orderDiscountTooltip.vue";
import {
  getPurchaseDetailSaleInfo,
  getKuaidi,
  expressStep,
  queryOrderExpressDeliveryListByOrderId,
} from "@/api/servicecenter/pendingPayment.js";
import { getOpsCertifyDetailsByShopId } from "@/api/qualification/qualification.js";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import { checkImages } from "@/utils/status";
import { returnFloat, correspondingVal, accMul } from "@/utils/validate";
import publicTable from "@/components/publicTable";
import { mapGetters } from "vuex";
export default {
  name: "PurchaseDetail",
  components: { publicTable, Tabs, orderDiscountTooltip },
  data() {
    return {
      returnFloat: returnFloat,
      accMul: accMul,
      orderLogisticsList: [],
      tabsList: [
        // tabs 传的值
        {
          name: "1",
          label: "三方物流",
          value: 0,
        },
        {
          name: "2",
          label: "自主配送",
          value: 0,
        },
      ],
      tabsActiveName: "1",
      activeName: "1", // 手风琴展开
      expressData: {
        step: "",
      },
      shopCertify: null, // 商户资质详情（ops/detailsNew 返回）
      radio: "",
      isBtnLoading: false,
      form: {
        nums: "",
        companyName: "",
        company: "",
      },
      isLoading: false,
      paydialog: false,
      id: "",
      orderId: "",
      list: [],
      orderList: {},
      icon: require("@/icons/img/icon_detail_status.png"),
      indexStep: 0,
      pageObj: {
        // 分页对象
        isShow: false,
        position: "right", // 分页组件位置
        total: 0,
        page: {
          size: 10,
          current: 1,
          goodsName: "",
          supplierId: "",
          type: "",
        },
      },
      tableData: [],
      columObj: {
        tableName: "multipleTable",
        // 选择框
        isShow: false,
        selection: false,
        // 选择框根据条件是否可选
        selectable: () => {
          return true;
        },
        lazy: "true",
        loading: false,
        // column列,columType(列类型,可选text(默认为普通文字模式),input(input可编辑框),switch(switch开关),image(图片),operation(操作按钮))
        // prop(参数),label(列名),width(宽度),align(对齐方式),sortable(是否支持排序)
        columnData: [
          {
            imageText: true,
            prop: "image",
            prop2: "name",
            prop3: "factory",
            label: "商品信息",
            width: "300",
            align: "left",
            sortable: false,
            ownDefinedReturn: (row) => {
              return row.factory;
            },
          },
          {
            text: true,
            prop: "specification",
            label: "规格",
            width: "",
            align: "center",
            ownDefinedReturn: (row) => {
              // returnFloat(accMul(row.qty, row.price))
              return row.specification;
            },
          },
          {
            ownDefined: true,
            prop: "price",
            label: "单价",
            width: "",
            align: "center",
            ownDefinedReturn: (row) => {
              return "￥" + returnFloat(row.price);
            },
          },
          {
            text: true,
            prop: "coupon",
            label: "优惠券",
            width: "200",
            align: "center",
          },
          {
            text: true,
            prop: "batchNumber",
            label: "批号",
            width: "200",
            align: "center",
          },
          {
            text: true,
            prop: "traceableCode",
            label: "溯源码",
            width: "200",
            align: "center",
          },
          {
            smallPrice: true,
            // ownStyle: true,
            prop: "qty",
            prop2: "price",
            prop3: "couponDiscount",
            slot: true,
            label: "小计",
            width: "140",
            align: "center",
            // ownDefinedReturn: (row) => {
            //   return returnFloat(accMul(row.qty, row.price));
            // },
          },
        ],
      },
      isQrCode: false,
      qrcode: null,
      total: "",
      orderPayId: "",
      status: "",
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    ...mapState("App", {
      selectList: "selectList",
    }),
    getStatus() {
      return (type, status) => checkImages(type, status);
    },
    // 商户资质中的仓库地址（fieldName: pxnxpldhom）
    deliveryAddress() {
      const list = (this.shopCertify && this.shopCertify.commonFieldList) || [];
      const item = list.find((f) => f.fieldName === "pxnxpldhom");
      return (item && item.fieldValue) || "";
    },
    // 物流时间线：在末尾追加「发货」节点（child 为最新在上，发货是最早事件）
    expressChild() {
      const child = (this.expressData && this.expressData.child) || [];
      if (!child.length) return child;
      const deliveryNode = {
        step: "发货",
        description: this.deliveryAddress
          ? `（发货地址：${this.deliveryAddress}）`
          : "",
      };
      return [...child, deliveryNode];
    },
  },
  methods: {
    // 计算总优惠
    getSumSalePrice(a, b, c) {
      let sum = 0;
      if (a) {
        sum += parseFloat(a);
      }
      if (b) {
        sum += parseFloat(b);
      }
      if (c) {
        sum += parseFloat(c);
      }
      return sum.toFixed(2);
    },
    //切换tabs按钮
    handleChange() {
      this.form.companyName = "";
      this.form.nums = "";
      if (this.tabsActiveName == "1") {
        return;
      }
    },
    handleSelect(e) {
      this.form.company = e.value;
    },
    querySearchAsync(queryString, cb) {
      getKuaidi({ name: queryString }).then((res) => {
        console.log(res.data);
        cb(res.data);
      });
    },

    getData() {
      getPurchaseDetailSaleInfo(this.id)
        .then((res) => {
          this.list = res.data.orderDetailVo;
          this.statusStyle(res.data.status);
          this.tabsActiveName = "1";
          this.orderList = res.data;
          if (this.orderList.beDelivery == "1") {
            this.tabsActiveName = "2";
            this.form.companyName = this.orderList.deliveryDriver;
            this.form.nums = this.orderList.contactsPhone;
          }
          if (this.orderList.status == "2") {
            this.tabsActiveName = "1";
            this.form.companyName = this.orderList.kuaidiName;
            this.form.nums = this.orderList.number;
            this.form.company = this.orderList.kuaidiId;
          }
          this.queryOrderExpress();
          this.getShopCertify();
        })
        .catch(() => {
          this.isLoading = false;
        });
      // expressStep({ orderId: this.id }).then((res) => {
      //   if (res.code == 0 && res.data) {
      //     this.expressData = res.data;
      //   } else {
      //     // this.$message.error('暂无数据')
      //   }
      // });
    },

    statusStyle(status) {
      console.log("status");
      status = Number(status);
      // 1.待付款,2.待发货, 3.已发货,4.待收货，5.交易取消, 6申请退款 7.已退款  8.已完成
      // 1待付款 2.待发货 3.配送中 4.待收货 5.交易取消, 6申请退款 7.已退款  8 配送完成 9 已完成 10 售后  11 待审核 new
      if (status == 1) {
        this.indexStep = 1;
      } else if (status == 2 || status == 11) {
        this.indexStep = 2;
      } else if (status == 3) {
        this.indexStep = 3;
      } else if (status == 8 || status == 4) {
        this.indexStep = 4;
      } else if (status == 9 || status == 10) {
        this.indexStep = 5;
      } else {
        this.indexStep = 0;
      }
    },
    // 当前选择的三方物流
    choseLogistics(type) {
      let item = {};
      for (let i = 0; i < this.orderLogisticsList.length; i++) {
        if (
          this.orderLogisticsList[i].expressDeliveryNumber ==
          this.orderLogistics
        ) {
          if (type == 0) {
            item = this.orderLogisticsList[type];
          } else {
            item = this.orderLogisticsList[i];
          }
          this.form.company = item.kuaidiId;
          this.form.companyName = item.kuaidiName;
          this.form.nums = item.expressDeliveryNumber;
          this.form.orderId = this.id;
          this.form.orderExpressDeliveryId = item.id;
          this.orderList.kuaidiName = item.kuaidiName;
          this.orderList.kuaidiId = item.kuaidiId;
          this.orderList.number = item.expressDeliveryNumber;
        }
      }
      this.getExpressStep();
    },
    //  获取快递100物流信息
    getExpressStep() {
      console.log(this.form.orderExpressDeliveryId);
      if (!this.form.orderExpressDeliveryId) return;
      expressStep({
        orderId: this.id,
        orderExpressDeliveryId: this.form.orderExpressDeliveryId,
      }).then((res) => {
        if (res.code == 0 && res.data) {
          this.expressData = res.data;
        } else {
          this.expressData = [];
          // this.$message.error('暂无数据')
        }
      });
    },
    // 查询商户资质详情（用于时间线「发货」节点的发货地址）
    getShopCertify() {
      const shopId =
        this.orderList.payeeShopId || this.orderList.payeeShopCode || "";
      if (!shopId) return;
      getOpsCertifyDetailsByShopId(shopId).then((res) => {
        if (res.code == 0 && res.data) {
          this.shopCertify = res.data;
        }
      });
    },
    // 查询订单物流信息
    queryOrderExpress() {
      queryOrderExpressDeliveryListByOrderId({
        orderId: this.id,
      })
        .then((res) => {
          this.orderLogisticsList = res.data;
          this.orderLogistics = res.data[0].expressDeliveryNumber;
          // console.log(this.orderLogistics, 'this.orderLogistics')
          // console.log(res, 'resresresres')
          this.choseLogistics();
        })
        .catch((err) => {});
    },
    // 切换物流单号
    handleClick() {
      this.choseLogistics();
    },
  },
  mounted() {
    const { id, orderId } = this.$route.query;
    this.id = id;
    this.orderId = orderId;
    this.getData();
    // expressStep({ orderId: this.id }).then((res) => {
    //   if (res.code == 0 && res.data) {
    //     this.expressData = res.data;
    //   } else {
    //     // this.$message.error('暂无数据')
    //   }
    // });
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/main";

.classification {
  .lists {
    height: auto !important;
  }

  background: #eee;

  .commodity {
    ::v-deep .el-table {
      .el-table__header {
        thead {
          th {
            background-color: #fff !important;
          }
        }
      }
    }

    .commodity_info {
      display: flex;
      justify-content: flex-start;
      flex: 1;
      align-items: center;
      height: 100px;

      .img {
        width: 80px;
        height: 80px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .goodsInfo {
        .name {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .factory {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }

  .fl_cen {
    justify-content: flex-start;
  }

  .list_input {
    margin-top: 0px;
  }

  ::v-deep .el-tabs__header {
    line-height: inherit;
    height: auto;
  }

  .info_list {
    ::v-deep .el-tabs__header {
      line-height: inherit;
      height: auto;
    }

    ::v-deep .el-tabs__item {
      height: auto;
      line-height: inherit;
      font-size: 14px;
    }
  }
}

.headerTabs {
  height: 70px;
  margin-bottom: 20px;
}
</style>
